angular.module('common.directives').directive('edgeListV2', function () {
  return {
    templateUrl: './templates/edgeList.view.html?t=' + webpackHash,
    controller: 'edgeListController',
    link: function ($scope, $element, attributes, $interval) {
      $scope.$on('$destroy', function handleDestroyEvent () {
        $scope.stopPing()
      })
    }
  }
})
